<template>
  <CompanyWrapper :isOpenEvent="isOpenEvent">
    <main class="main">
      <!-- パンくずリスト -->
      <ol class="breadcrumb-trail__list">
        <li class="breadcrumb-trail__list--item">
          <router-link
            v-if="isOpenEvent"
            :to="{ path: `/${langPath}` }"
            class="breadcrumb-trail__list--item__link"
          >
            TOP
          </router-link>
          <router-link
            v-else
            :to="{ path: `/company/summary` }"
            class="breadcrumb-trail__list--item__link"
          >
            EventList
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item" v-if="!isOpenEvent">
          <router-link
            :to="{ path: `/company/event/${nassId}` }"
            class="breadcrumb-trail__list--item__link"
          >
            Detail
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{
              path: `/company/confirmation`,
              query: {
                event: nassId,
              },
            }"
            class="breadcrumb-trail__list--item__link"
          >
            {{ Confirmation.title[lang] }}
          </router-link>
        </li>
      </ol>
      <h1 class="page-title">
        {{ Confirmation.title[lang] }}
      </h1>
      <p class="page-description">{{ Confirmation.about[lang] }}</p>
      <!-- 入力が無効の時 -->
      <Alert v-if="isNotFound" :lang="lang" :alertText="alertText"></Alert>
      <!-- キャッシュが残っていてサーバーエラーになるとき -->
      <Alert v-if="isCacheError" :lang="lang" :alertText="alertText2"></Alert>
      <section id="js-form" class="oauth-section">
        <div class="absolute-center">
          <dl class="oauth-form__dl">
            <dt class="oauth-form__dl--dt">
              {{ Confirmation.event[lang] }}
            </dt>
            <dd class="oauth-form__dl--dd">
              {{ eventName }}{{ itemEventName }}
            </dd>
          </dl>
          <dl class="oauth-form__dl">
            <dt class="oauth-form__dl--dt">
              {{ Confirmation.form.email[lang] }}
            </dt>
            <dd class="oauth-form__dl--dd">
              {{ Confirmation.form.emailPlaceHolder[lang] }}
            </dd>
            <dd class="oauth-form__dl--dd">
              <label>
                <input
                  v-model="eMail"
                  :placeholder="Confirmation.form.email[lang]"
                  :class="{ alert: isMailAlert }"
                  class="form-input"
                  type="email"
                  autocomplete="on"
                  required
                />
              </label>
            </dd>
          </dl>
          <dl class="oauth-form__dl">
            <dt class="oauth-form__dl--dt">
              {{ Confirmation.form.code[lang] }}
            </dt>
            <dd class="oauth-form__dl--dd">
              {{ Confirmation.form.codePlaceHolder[lang] }}
            </dd>
            <dd class="oauth-form__dl--dd">
              <label>
                <input
                  v-model="appAuthId"
                  :placeholder="Confirmation.form.code[lang]"
                  :class="{ alert: isAuthAlert }"
                  class="form-input"
                  type="text"
                  required
                />
              </label>
            </dd>
          </dl>
          <div class="oauth-form__button">
            <PrimaryButton type="button" @click.native="confEvent">
              {{ Confirmation.form.conf[lang] }}
            </PrimaryButton>
          </div>
        </div>
      </section>

      <!-- トークン無効 -->
      <InvalidToken
        :email="eMail"
        :appauthid="appAuthId"
        :lang="lang"
        :eventId="eventId"
        :eventName="eventName"
        v-if="isInvalidToken"
        class="child-auth-section"
      ></InvalidToken>

      <!-- 連携未完了 -->
      <NotCooperation
        :email="eMail"
        :appauthid="appAuthId"
        :lang="lang"
        :eventName="eventName"
        class="child-auth-section"
        v-if="isNotCooperation"
      ></NotCooperation>

      <!-- 連携完了 -->
      <Cooperation
        :email="eMail"
        :appauthid="appAuthId"
        :lang="lang"
        :langPath="langPath"
        :nassId="nassId"
        :eventId="eventId"
        :eventName="eventName"
        :runnerName="runnerName"
        class="child-auth-section"
        v-if="isCooperation"
      ></Cooperation>
    </main>
  </CompanyWrapper>
</template>

<script>
import CompanyWrapper from "../../../../components/sp/company/CompanyWrapper";
import NotEnglish from "../../../../components/sp/NotEnglish";
import Alert from "../../../../components/sp/oauth/Alert";
import Cooperation from "../../../../components/sp/oauth/Cooperation";
import NotCooperation from "../../../../components/sp/oauth/NotCooperation";
import InvalidToken from "../../../../components/sp/oauth/InvalidToken";
import PrimaryButton from "../../../../components/sp/oauth/PrimaryButton";
import { RepositoryFactory } from "../../../../api/RepositoryFactory";
import cognito from "../../../../plugins/cognito";
import Confirmation from "../../../../assets/constants/confirmation/confirmation.json";

export default {
  data() {
    return {
      eMail: null,
      appAuthId: null,
      isEnglishNotAvailable: false,
      isMailAlert: false,
      isAuthAlert: false,
      isNotFound: false,
      isCacheError: false,
      isInvalidToken: false,
      isNotCooperation: false,
      isCooperation: false,
      isOpenEvent: false,
      dataEventList: [],
      dataConf: null,
      nassId: "",
      eventId: "",
      eventName: "",
      runnerName: "",
      itemEventName: "",
    };
  },
  async created() {
    const EventRepository = RepositoryFactory.get("event");
    const isCompany = this.$route.path.includes("company");
    const nassId = this.$route.query.event;
    const params = {
      code: nassId,
      lang: this.lang,
      is_company_event: isCompany || "",
      company_user_name: cognito.getUserName() || "",
    };
    const response = await EventRepository.getEvent(params);
    this.nassId = nassId;
    this.eventName = response.data.name;
    this.eventId = response.data.text.event_id;
    this.isOpenEvent = response.data.text.open_event_flag;
    sessionStorage.setItem("eventId", this.eventId);
    sessionStorage.setItem("nassEventId", this.nassId);
    await this.initialFlag();
    await this.formScroll("js-form");
  },
  methods: {
    initialFlag: function () {
      // 初期化
      this.eMail = "";
      this.appAuthId = "";
      this.isNotFound = false;
      this.isCacheError = false;
      this.isInvalidToken = false;
      this.isCooperation = false;
      this.isNotCooperation = false;
    },
    formScroll: function (elementId) {
      const element = document.getElementById(elementId);
      element.scrollIntoView({ behavior: "smooth" });
    },
    confEvent: async function () {
      // 初期化
      this.isNotFound = false;
      this.isCacheError = false;
      this.isInvalidToken = false;
      this.isCooperation = false;
      this.isNotCooperation = false;
      // 入力判定
      if (!this.eMail && !this.appAuthId) {
        this.isMailAlert = true;
        this.isAuthAlert = true;
        return;
      }
      if (!this.eMail) {
        this.isMailAlert = true;
        return;
      }
      if (!this.appAuthId) {
        this.isAuthAlert = true;
        return;
      }
      // 認証の際、外部サイトに遷移するため一時的に保存する
      sessionStorage.setItem("email", this.eMail);
      sessionStorage.setItem("app_auth_code", this.appAuthId);
      sessionStorage.setItem("event_flag", "company");
      // 認証状態確認
      const data = {
        event_id: this.eventId,
        email: this.eMail,
        app_auth_code: this.appAuthId,
      };
      try {
        const OauthUserRepository = RepositoryFactory.get("oauth");
        const response = await OauthUserRepository.postConf(data);
        this.dataConf = response.data;
        this.runnerName = response.data.runnerName;
      } catch (e) {
        // email or id が見つからなかった場合
        if (e.response.status === 404) {
          this.isNotFound = true;
          return;
        } else {
          this.isCacheError = true;
          return;
        }
      }
      // アクセストークンが無効
      if (!this.dataConf.isRunkeeperToken) {
        this.isInvalidToken = true;
        return;
      }
      // 未連携
      if (!this.dataConf.isRegisterApplication) {
        this.isNotCooperation = true;
        return;
      }
      // 連携済み
      if (this.dataConf.isRegisterApplication) {
        this.isCooperation = true;
      }
    },
  },
  computed: {
    Confirmation: function () {
      return Confirmation;
    },
    alertText: function () {
      return "not-found";
    },
    alertText2: function () {
      return "cache-error";
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  watch: {
    eMail: function () {
      this.isMailAlert = false;
      this.isNotFound = false;
      this.isCacheError = false;
    },
    appAuthId: function () {
      this.isAuthAlert = false;
      this.isNotFound = false;
      this.isCacheError = false;
    },
  },
  components: {
    CompanyWrapper,
    NotEnglish,
    Alert,
    Cooperation,
    NotCooperation,
    InvalidToken,
    PrimaryButton,
  },
  name: "Confirmation",
};
</script>

<style scoped>
.main {
  .page-title {
    margin: 40px 0 0 0;
    line-height: 1.25;
    padding: 0 0 0 15px;
    border-left: solid 8px var(--defaultBlackColor);
    font-size: 32px;
    font-weight: 900;
  }

  .page-description {
    margin: 40px 0 0 0;
    line-height: 1.5;
    white-space: pre-line;
  }

  .oauth-section {
    min-height: 100vh;
    position: relative;

    .absolute-center {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .oauth-form__dl {
        &:not(:first-of-type) {
          margin: 20px 0 0 0;
        }

        &--dt {
          margin: 25px 0 0 0;
          font-size: 16px;
          font-weight: bold;
          color: var(--defaultBlackColor);
        }

        &--dd {
          margin: 10px 0 0 0;
          font-size: 14px;

          .form-input {
            width: 100%;
            height: 50px;
            padding: 0 0 0 10px;
            border: solid 1px var(--grayColor3);
            font-size: 16px;
          }

          .alert {
            background-color: var(--alertColor2);
            border: 1px solid var(--alertColor);
          }
        }
      }

      .oauth-form__button {
        margin: 30px 0 0 0;
      }
    }
  }
  .child-auth-section {
    /*スクロールの余白を考慮する*/
    padding: 60px 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sp/company/confirmation/Confirmation.vue